import { EVMChain } from '../../types';
import cryptoVerseAi from './CryptoverseAI.json';
import nftMarketplace from './NFTMarketplace.json';
/**
 * Ethereum-only launch: Version.sol CURRENT=1 (latest synced ABIs).
 *
 * Only the marketplace address is configured per chain. The NFT contract address is
 * an immutable on the marketplace, so it is derived on-chain at init.
 */
export const DEPLOYED_CONTRACTS = {
    [EVMChain.Ethereum]: [
        {
            nft_address: '0x28288cFAb8412FbaEBE116879F553dC1447E2a9B',
            market_address: '0x3c95b162d3aadd864be718e8b2553588e62a5379',
            nft_abi: cryptoVerseAi.abi,
            market_abi: nftMarketplace.abi,
        },
    ],
};
